export default __webpack_public_path__ + "static/media/money.56532152.svg";